import React, { useEffect } from 'react';
import $image_url from 'js/utils/image_url';
import { SelectQuestion, AnswerType, QuestionType } from './types';
import { getIcon } from './helpers';
import { PingAnswer } from './PingAnswer';
import {
  SurveyQuestion,
  SurveyQuestionPrompt,
  SurveyAnswersContainer,
  AnswerContainer,
  AnswerIcon,
  AnswerText,
} from './styles/QuestionStyles';
// @ts-expect-error ts(2307)
import i18nResourcesAnswer from '@alienfast/i18next-loader?include=**/reg_path/signup_to_download/survey/MultipleChoiceTilesQuestion.json!config/locales_i18next/index.js';
// @ts-expect-error ts(2307)
import i18nResourcesPrompt from '@alienfast/i18next-loader?include=**/reg_path/signup_to_download/survey/BaseQuestion.json!config/locales_i18next/index.js';
import addResources from 'js/i18next/addResources';
import { useTranslationTest } from 'js/utils/hooks';

const ANSWER_TRANSLATION_NAMESPACE =
  'RegPath.SignupToDownload.MultipleChoiceTilesQuestion';
const PROMPT_TRANSLATION_NAMESPACE = 'RegPath.SignupToDownload.BaseQuestion';
addResources(i18nResourcesAnswer, ANSWER_TRANSLATION_NAMESPACE);
addResources(i18nResourcesPrompt, PROMPT_TRANSLATION_NAMESPACE);

interface Props {
  userTaggingQuestion: SelectQuestion;
  selectAnswer: (answerIndex: number) => void;
  selectedAnswers: number[];
  setQuestionLoadTime: () => void;
  answerType: AnswerType;
  customAnswer?: string | null;
  setCustomText?: (text: string) => void;
}

export const Question: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const {
    userTaggingQuestion,
    selectAnswer,
    selectedAnswers,
    setQuestionLoadTime,
    answerType,
    setCustomText,
    customAnswer,
  } = props;
  const { questionType, userTags, prompt, userTaggingType } =
    userTaggingQuestion;
  const [tAnswer] = useTranslationTest(ANSWER_TRANSLATION_NAMESPACE, true);
  const [tPrompt] = useTranslationTest(PROMPT_TRANSLATION_NAMESPACE, true);
  const multiColumn = questionType === QuestionType.SingleSelectColumns;

  useEffect(setQuestionLoadTime, [setQuestionLoadTime]);

  return (
    <SurveyQuestion>
      <SurveyQuestionPrompt>
        {tPrompt(`${prompt}`)}
        {questionType === QuestionType.MultiSelect &&
          ` (${tPrompt('select').replace('.', '').toLowerCase()})`}
      </SurveyQuestionPrompt>
      <SurveyAnswersContainer multiColumn={multiColumn}>
        {userTags.map((tag, index) =>
          answerType === AnswerType.default ? (
            <AnswerContainer
              multiColumn={multiColumn}
              key={index}
              highlighted={selectedAnswers.includes(index)}
              onClick={() => selectAnswer(index)}
            >
              <AnswerIcon src={$image_url(getIcon(tag.userTagText))} />
              <AnswerText>{tAnswer(`${tag.userTagText}`)}</AnswerText>
            </AnswerContainer>
          ) : (
            <PingAnswer
              key={index}
              answerType={answerType}
              selected={selectedAnswers.includes(index)}
              onClick={() => selectAnswer(index)}
              text={tAnswer(`${tag.userTagText}`)}
              otherTextInput={tag.userTagText === 'other'}
              tagType={userTaggingType}
              setCustomText={setCustomText}
              customAnswer={customAnswer}
            />
          ),
        )}
        {props.children}
      </SurveyAnswersContainer>
    </SurveyQuestion>
  );
};

export default Question;
